/**
 * This module (must be initialized after slick slider.
 * @module BuyBox
 * @return {Object} public methods.
 */

const BuyBox = (function () {
    var $win;
    var $doc;
    var $buyBox;
    var $buyBoxWrapper;
    var $headerTop;
    var $footer;
    var $additionalProductsWrapper;
    var offsetTop;
    var offsetBottom;

    function init() {
        $buyBox = $('.product-buy');

        if ($buyBox.length === 0) return false;

        getDOMElements();
        addEventListener();

        // set the initial offsets
        updateOffsetTop();
        updateOffsetBottom();
    }

    function getDOMElements() {
        $win = $(window);
        $doc = $(document);
        $buyBoxWrapper = $('.product-buy-wrapper');
        $headerTop = $('.header__top');
        $footer = $('.footer');
        $additionalProductsWrapper = $('.additional-products-wrapper');
    }

    function addEventListener() {
        $win.on('resize', onWindowResize);
        $doc.on('tab:clicked', onTabClicked);
        $doc.on('scroll', onDocumentScroll);
    }

    function onWindowResize() {
        reset();
        updateOffsetTop();
        updateOffsetBottom();
    }

    function onTabClicked() {
        updateOffsetBottom();
    }

    function onDocumentScroll() {
        var scrollTop = $win.scrollTop();
        var scrollBottom;

        if (matchMedia('only screen and (max-width: 704px)').matches) {
            // on mobile
            scrollBottom = scrollTop + $win.height();
            handleStickyOnMobile(scrollTop, scrollBottom);
        } else {
            // on desktop
            scrollBottom = scrollTop + $buyBoxWrapper.height();
            handleStickyOnDesktop(scrollTop, scrollBottom);
        }
    }

    function handleStickyOnMobile(scrollTop, scrollBottom) {
        if (scrollTop >= offsetTop && scrollBottom < offsetBottom && !$buyBox.hasClass('product-buy--sticky')) {
            // user scrolled down past the bottom of the product box wrapper
            $buyBoxWrapper.height($buyBoxWrapper.height() - 30);
            $buyBox.addClass('product-buy--sticky');
        } else if (scrollTop < offsetTop && $buyBox.hasClass('product-buy--sticky')) {
            // user scrolled up to the bottom of the product box wrapper
            $buyBox.removeClass('product-buy--sticky');
            $buyBoxWrapper.height('auto');
        } else if (scrollBottom >= offsetBottom && $buyBox.hasClass('product-buy--sticky')) {
            // user scrolled down past the top of the footer
            $buyBox.removeClass('product-buy--sticky');
            $buyBoxWrapper.height('auto');
        } else if (scrollBottom < offsetBottom && scrollTop > offsetTop && !$buyBox.hasClass('product-buy--sticky')) {
            // user scrolled up to the top of the footer
            $buyBoxWrapper.height($buyBoxWrapper.height() - 30);
            $buyBox.addClass('product-buy--sticky');
        }
    }

    function handleStickyOnDesktop(scrollTop, scrollBottom) {
        if (scrollTop >= offsetTop && scrollBottom < offsetBottom && !$buyBox.hasClass('product-buy--sticky')) {
            // user scrolled down past the top of the product box wrapper
            $buyBoxWrapper.height($buyBox.outerHeight());
            $buyBox.addClass('product-buy--sticky');
        } else if (scrollTop < offsetTop && $buyBox.hasClass('product-buy--sticky')) {
            // user scrolled up to the top of the product box wrapper
            $buyBox.removeClass('product-buy--sticky');
            $buyBoxWrapper.height('auto');
        } else if (scrollBottom >= offsetBottom && $buyBox.hasClass('product-buy--sticky')) {
            // user scrolled down to the top of the additional products wrapper or footer
            if (matchMedia('only screen and (min-width: 705px) and (max-width: 751px)').matches) {
                $buyBox.css('top', (($buyBoxWrapper.height() - (offsetBottom - scrollTop + $headerTop.height())) * -1) + 'px');
            } else {
                $buyBox.css('top', (($buyBoxWrapper.height() - (offsetBottom - scrollTop)) * -1) + 'px');
            }
        } else if (scrollBottom < offsetBottom && scrollTop > offsetTop && $buyBox.hasClass('product-buy--sticky')) {
            // user scrolled up past the top of the additional products wrapper or footer
            if (matchMedia('only screen and (min-width: 705px) and (max-width: 751px)').matches) {
                $buyBox.css('top', $headerTop.height() + 'px');
            } else {
                $buyBox.css('top', '0');
            }
        }
    }

    function updateOffsetTop() {
        if (matchMedia('only screen and (max-width: 704px)').matches) {
            // mobile offset top
            offsetTop = $buyBoxWrapper.offset().top + $buyBoxWrapper.height() - $headerTop.height();
        } else if (matchMedia('only screen and (min-width: 705px) and (max-width: 751px)').matches) {
            // desktop offset top with header bar
            offsetTop = $buyBox.offset().top - $headerTop.height();
        } else {
            // desktop offset top without header bar
            offsetTop = $buyBox.offset().top;
        }
    }

    function updateOffsetBottom() {
        if (matchMedia('only screen and (max-width: 704px)').matches) {
            // mobile offset bottom
            offsetBottom = $footer.offset().top;
        } else {
            // desktop offset bottom
            if ($additionalProductsWrapper.length) {
                offsetBottom = $additionalProductsWrapper.offset().top;
            } else {
                offsetBottom = $footer.offset().top;
            }

            if (matchMedia('only screen and (min-width: 705px) and (max-width: 751px)').matches) {
                offsetBottom -= $headerTop.height();
            }
        }
    }

    function reset() {
        $buyBox.removeClass('product-buy--sticky');
        $buyBox.css('top', 'auto');
        $buyBoxWrapper.height('auto');
    }

    // Return public methods
    return {
        init: init
    };
})();

window.BuyBox = BuyBox;
export default BuyBox;
